var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "fixHeard", staticClass: "fix_heard" },
    [
      _c("div", { staticClass: "navcontainer" }, [
        _c("div", { staticClass: "Logo" }, [
          _c(
            "div",
            { staticClass: "icon" },
            [
              _c("router-link", { attrs: { to: { path: "/home" } } }, [
                _c("img", {
                  attrs: {
                    src: require("../../../static/img/infoLogo.png"),
                    alt: ""
                  }
                })
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tabs" },
            [
              _vm._l(_vm.tabsList, function(item, inx) {
                return [
                  _c("div", { key: inx, staticClass: "item" }, [
                    _c(
                      "p",
                      {
                        staticClass: "tabs_item",
                        on: {
                          click: function($event) {
                            return _vm.handleItem(item)
                          },
                          mouseover: function($event) {
                            return _vm.mouseenter(item)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(item.name) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "top_left" }, [
            _c("i", {
              staticClass: "iconfont icon-appstore",
              on: {
                click: function($event) {
                  _vm.drawer = true
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _vm._m(0)
      ]),
      _vm._v(" "),
      _vm.hoverId === 2
        ? _c(
            "div",
            {
              staticClass: "item_navcon",
              on: {
                mouseleave: function($event) {
                  return _vm.mouseleave()
                }
              }
            },
            [
              _c("div", { staticClass: "show_box" }, [
                _c("div", { staticClass: "show_item" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text" },
                    [
                      _c("div", { staticClass: "title" }, [_vm._v("数字电视")]),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        { attrs: { to: { path: "/productChip" } } },
                        [_c("p", [_vm._v("直播卫星ABS—S系统解决方案")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        { attrs: { to: { path: "/productChip1" } } },
                        [_c("p", [_vm._v("国标DTMB地面数字电视解决方案")])]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "show_item" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text" },
                    [
                      _c("div", { staticClass: "title" }, [_vm._v("智慧零售")]),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        { attrs: { to: { path: "/resale" } } },
                        [_c("p", [_vm._v("智慧零售系统解决方案")])]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "show_item" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text" },
                    [
                      _c("div", { staticClass: "title" }, [_vm._v("智慧学习")]),
                      _vm._v(" "),
                      _c("router-link", { attrs: { to: { path: "/study" } } }, [
                        _c("p", [_vm._v("企业学习系统解决方案")])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm._m(4)
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hoverId === 5
        ? _c(
            "div",
            {
              staticClass: "item_navcon",
              on: {
                mouseleave: function($event) {
                  return _vm.mouseleave()
                }
              }
            },
            [
              _c("div", { staticClass: "show_box" }, [
                _c("div", { staticClass: "show_item item1" }, [
                  _c(
                    "div",
                    {
                      staticClass: "box",
                      on: {
                        click: function($event) {
                          return _vm.goDetail(1)
                        }
                      }
                    },
                    [
                      _vm._m(5),
                      _vm._v(" "),
                      _c("div", { staticClass: "name" }, [_vm._v("企业简介")])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "line" })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "show_item item1" }, [
                  _c(
                    "div",
                    {
                      staticClass: "box",
                      on: {
                        click: function($event) {
                          return _vm.goDetail(2)
                        }
                      }
                    },
                    [
                      _vm._m(6),
                      _vm._v(" "),
                      _c("div", { staticClass: "name" }, [_vm._v("发展历程")])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "line" })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "show_item item1" }, [
                  _c(
                    "div",
                    {
                      staticClass: "box",
                      on: {
                        click: function($event) {
                          return _vm.goDetail(3)
                        }
                      }
                    },
                    [
                      _vm._m(7),
                      _vm._v(" "),
                      _c("div", { staticClass: "name" }, [_vm._v("荣誉资质")])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "line" })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "show_item item1" }, [
                  _c(
                    "div",
                    {
                      staticClass: "box",
                      on: {
                        click: function($event) {
                          return _vm.goDetail(0)
                        }
                      }
                    },
                    [
                      _vm._m(8),
                      _vm._v(" "),
                      _c("div", { staticClass: "name" }, [_vm._v("联系我们")])
                    ]
                  )
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "",
            visible: _vm.drawer,
            "with-header": false,
            "append-to-body": true,
            direction: "ltr"
          },
          on: {
            "update:visible": function($event) {
              _vm.drawer = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-menu",
                {
                  attrs: {
                    "default-active": _vm.activeIndex,
                    mode: "vertical",
                    "background-color": "#1b1825",
                    "text-color": "#fff",
                    "active-text-color": "#7b7981"
                  },
                  on: { select: _vm.menuSelect, open: _vm.handleOpen }
                },
                [
                  _vm._l(_vm.tabsList, function(item) {
                    return [
                      _c(
                        "el-submenu",
                        {
                          key: item.id,
                          attrs: { index: item.id.toString(), collapse: true }
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _c("span", [_vm._v(_vm._s(item.name))])
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-menu-item-group",
                            [
                              _vm._l(item.children, function(itm) {
                                return [
                                  _c(
                                    "router-link",
                                    {
                                      key: itm.id,
                                      attrs: { to: itm.path, tag: "div" }
                                    },
                                    [
                                      _c(
                                        "el-menu-item",
                                        {
                                          key: itm.id,
                                          attrs: { index: itm.id.toString() }
                                        },
                                        [_vm._v(_vm._s(itm.name))]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        ],
                        2
                      )
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "call" }, [
      _c(
        "div",
        { staticClass: "icon_calls", staticStyle: { "margin-right": "10px" } },
        [
          _c("img", {
            attrs: { src: require("../../../static/img/phone.png"), alt: "" }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "text" }, [_c("p", [_vm._v("+86 21 61871158")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "iconfont icon-dianshi" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "iconfont icon-shop" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "iconfont icon-xuexi" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "show_item" }, [
      _c("div", { staticClass: "icon" }, [
        _c("i", { staticClass: "iconfont icon-lianjiedian-connection-points" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text" }, [
        _c("div", { staticClass: "title" }, [_vm._v("行业方案")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text_box", staticStyle: { display: "flex" } },
          [
            _c(
              "div",
              { staticClass: "left", staticStyle: { "margin-right": "20px" } },
              [
                _c("p", [_vm._v("智慧园区")]),
                _vm._v(" "),
                _c("p", [_vm._v("智慧环保")]),
                _vm._v(" "),
                _c("p", [_vm._v("智慧工地")])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _c("p", [_vm._v("智慧社区")]),
              _vm._v(" "),
              _c("p", [_vm._v("智慧照明")]),
              _vm._v(" "),
              _c("p", [_vm._v("智慧党建")])
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "iconfont icon-qiyexinxi" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "iconfont icon-timeAxis" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "iconfont icon-jifen" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "iconfont icon-comment" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa9c95b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa9c95b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/comcomponents/NavTop.vue
// module id = null
// module chunks = 